/** Pipe sizes the heating topology works with, smallest to largest */
export const NOMINAL_DIAMETERS = [25, 32, 50, 63, 80, 100] as const

export type NominalDiameter = (typeof NOMINAL_DIAMETERS)[number]
